import './ResultsHeader.css';

export const ResultsHeader = ({title, subtitle}) => {
    return (
        <header className='resultsColumnHeader'> 
            <h2 className='resultsColumnTitle'>{title}</h2>
            <span className='resultsColumnSpan'>{subtitle}</span>
        </header>
    )
}